var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.authorized)?_c('div',{staticClass:"user-profile-header"},[_c('i',{staticClass:"fas fa-sign-out-alt fa-2x",on:{"click":_vm._logoutClick}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }